export default __webpack_public_path__ + "static/media/mapmyrun_logo.105011d2.png";